import React, {useContext} from "react";
import PageTitle from "../../../layout/PageTitle";
import {useMutation, useQuery} from "@apollo/client";
import {AddButton, DeleteButton, EditButton} from "../../../helpers/ButtonHelper";
import ListTable from "../../shared/ListTable";
import {deleteItem, tableImageTag} from "../../../helpers/Api";
import {deleteMenuMutation, getClientMenus, getMenus} from "./MenuQueries";
import {Container} from "react-bootstrap";
import {UserContext} from "../../../context/UserContext";
import {Link} from "react-router-dom";

const MenusList = ({clientId = null}) => {
  let options = {fetchPolicy: 'network-only'}
  let query = getMenus
  const {plan: {menusLimit, menusCount}} = useContext(UserContext)

  if (clientId) {
    options.variables = {clientId: clientId}
    query = getClientMenus
  }

  const {data} = useQuery(query, options)
  const [deleteCall] = useMutation(deleteMenuMutation, {refetchQueries: [getMenus]})

  const header = <tr>
    <th>Denumire</th>
    <th>Detalii</th>
    <th># Retete</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>
        <Link to={`/menus/${item.id}`}>
          {tableImageTag(item, {type: 'menu'})}
          {item.name}
        </Link>
      </td>
      <td>{item.details}</td>
      <td>{item.platesCount}</td>
      <td className='actions'>
        <EditButton to={`/menus/${item.id}`}/>
        <DeleteButton onClick={e => deleteItem(e, item.id, deleteCall, 'deleteMenu')}/>
      </td>
    </tr>
  }

  return (
    <Container>
      <PageTitle title='Meniuri' buttons={menusLimit > menusCount &&
        <AddButton to='/menus/new'/>
      }/>
      <div className="row justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.menus} header={header} listItem={listItem}/>
        </div>
      </div>
    </Container>
  )
};

export default MenusList;